/* eslint-disable no-console */
import { client } from "./supabase";

/**
 * Obtiene los activos y calcula la depreciación mensual para un año dado.
 * @param {string} pais - "Chile" o "Perú"
 * @param {number} year - Año para calcular (ej: 2024)
 * @returns {Promise<number[]>} Array de 12 elementos con la depreciación de cada mes
 */
export const getDepreciacionMensual = async (pais, year) => {
  try {
    const { data: activos, error } = await client.from("activos").select("*").eq("pais", pais).eq("eliminado", false);

    if (error) throw error;

    if (!activos || activos.length === 0) {
      return Array(12).fill(0);
    }

    // Calcular depreciación por mes
    const depreciacionPorMes = Array(12).fill(0);

    for (const activo of activos) {
      const costoTotal = parseFloat(activo.costo_unitario) * activo.cantidad;
      const vidaUtilMeses = activo.vida_util_meses || 60;
      const cuotaMensual = costoTotal / vidaUtilMeses;

      // Parsear fecha de compra (evitar problema de timezone)
      const [yearCompra, monthCompra] = activo.fecha_compra.split("-").map(Number);
      const fechaCompra = new Date(yearCompra, monthCompra - 1, 1);

      for (let mes = 0; mes < 12; mes++) {
        // Último día del mes a evaluar
        const finMes = new Date(year, mes + 1, 0);

        // El activo debe haber sido comprado antes o durante este mes
        if (fechaCompra > finMes) continue;

        // Calcular cuántos meses han pasado desde la compra hasta este mes
        const mesesDesdeCompra = (year - yearCompra) * 12 + mes - (monthCompra - 1);

        // Si ya pasó la vida útil, no deprecia más
        if (mesesDesdeCompra >= vidaUtilMeses) continue;

        // Si el mes de compra es este mismo mes, solo deprecia si compró antes del fin de mes
        if (mesesDesdeCompra < 0) continue;

        // Solo activos con estado "activo" o "en_reparacion" deprecian
        if (activo.estado !== "activo" && activo.estado !== "en_reparacion") continue;

        depreciacionPorMes[mes] += Math.round(cuotaMensual);
      }
    }

    return depreciacionPorMes;
  } catch (error) {
    console.error("Error en getDepreciacionMensual:", error);
    return Array(12).fill(0);
  }
};
